module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#twitter",
      toString: function () {
        return this.url;
      }
    }